var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container content-padding" }, [
    _vm.serviceRequest
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-8 offset-sm-2 col-12" }, [
            _c("h2", [
              _vm._v(
                _vm._s(_vm.$t("message.service_request.service_request_detail"))
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card panel-white" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("message.service_request.request")) +
                        " #" +
                        _vm._s(_vm.serviceRequest.id) +
                        " - " +
                        _vm._s(
                          _vm._f("multiLangName")(_vm.serviceRequest.service)
                        ) +
                        "\n            "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              !_vm.provider
                ? _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-4 text-left" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.service_request.status"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-8 text-right -status-new" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("multiLangName")(
                                  _vm.serviceRequest.service_request_status
                                )
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.serviceRequest.service_date
                ? _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-4 text-left" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.service_request.service_date")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-8 text-right" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("prettyDate")(
                                _vm.serviceRequest.service_date
                              )
                            ) +
                            "\n            "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.serviceRequest.duration_remark
                ? _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-4 text-left" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.service_request.service_date_duration_remark"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-8 text-right" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.serviceRequest.duration_remark) +
                            "\n            "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.serviceRequest.service_request_purpose
                ? _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-4 text-left" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.service_request.purpose"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-8 text-right" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("multiLangName")(
                                _vm.serviceRequest.service_request_purpose
                              )
                            ) +
                            "\n            "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-4 text-left" }, [
                    _c("label", [_vm._v(_vm._s(_vm.textData.labelType))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 text-right" }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm._f("multiLangName")(
                            _vm.serviceRequest.building_type
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-1" }, [
                      _vm._v(_vm._s(_vm.serviceRequest.building_size))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-4 text-left" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.service_request.address")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 text-right" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.serviceRequest.building_address) +
                        "\n              "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-black-50" }, [
                      _vm.serviceRequest.sub_district
                        ? _c("span", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("multiLangName")(
                                    _vm.serviceRequest.sub_district
                                  )
                                ) +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("multiLangName")(_vm.serviceRequest.district)
                          ) +
                          "\n                " +
                          _vm._s(
                            _vm._f("multiLangName")(
                              _vm.serviceRequest.address_province
                            )
                          ) +
                          "\n              "
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-4 text-left" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.service_request.remark")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 text-right" }, [
                    _c("div", {
                      directives: [
                        { name: "linkified", rawName: "v-linkified" }
                      ],
                      domProps: { innerHTML: _vm._s(_vm.serviceRequest.remark) }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.service_request.photos")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _vm._l(_vm.serviceRequest.service_request_photos, function(
                      picture,
                      index
                    ) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "col-4 p-2",
                            class: { "p-3": !_vm.$mq.phone }
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    _vm.galleryIndex = index
                                  }
                                }
                              },
                              [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy:background-image",
                                      value: picture.image_xl,
                                      expression: "picture.image_xl",
                                      arg: "background-image"
                                    }
                                  ],
                                  staticClass: "img-gallery"
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    }),
                    _vm._v(" "),
                    _c("Tinybox", {
                      attrs: {
                        images: _vm._.map(
                          _vm.serviceRequest.service_request_photos,
                          "image_xl"
                        ),
                        loop: "",
                        "no-thumbs": ""
                      },
                      model: {
                        value: _vm.galleryIndex,
                        callback: function($$v) {
                          _vm.galleryIndex = $$v
                        },
                        expression: "galleryIndex"
                      }
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              !_vm.provider
                ? _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-4 text-left" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.service_request.service_cost")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-8 text-right" }, [
                        _vm.serviceRequest.service_cost
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("currency")(
                                    _vm.serviceRequest.service_cost
                                  )
                                )
                              )
                            ])
                          : _c("span", { staticClass: "text-orange" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.service_request.evaluating_cost"
                                  )
                                )
                              )
                            ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "text-remark mb-3" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t(
                              "message.service_request.service_cost_remark"
                            )
                          ) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-block btn-outline-info",
                        attrs: {
                          href: "https://line.me/R/ti/p/%40hnk7011n",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("message.button.contact_admin")) +
                            "\n              "
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      : _c("div", { staticClass: "row" }, [_vm._m(0)])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col text-center" }, [
      _c("div", { staticClass: "mb-3" }, [
        _c("i", { staticClass: "fal fa-times-circle -status-alert fa-3x" })
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("No Data")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cf6a07f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cf6a07f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/serviceRequest/ServiceRequestDetailForPartner.vue
// module id = 2145
// module chunks = 0